import { Accordion } from "react-bootstrap";
import LocationModel from "./LocationModel";

function Location({ jobList }) {
  return (
    <Accordion className="footage-accordian">
      {jobList &&
        jobList.locations.length > 0 &&
        jobList.locations.map((value, index) => {
          return (
            <LocationModel
              FootageType={"Locations"}
              value={value}
              index={index}
            />
          );
        })}
    </Accordion>
  );
}

export default Location;
